<template>
  <CSidebar
    position="fixed"
    :unfoldable="sidebarUnfoldable"
    :visible="sidebarVisible"
    @visible-change="
      (event) =>
        $store.commit({
          type: 'updateSidebarVisible',
          value: event,
        })
    "
  >
    <CSidebarBrand class="bg-white">
      <img
        src="@/assets/brand/logo-bionic.png"
        alt=""
        height="35"
        class="sidebar-brand-full"
      />
      <img
        src="@/assets/brand/sygnet.png"
        alt=""
        height="35"
        class="sidebar-brand-narrow"
      />
    </CSidebarBrand>
    <AppSidebarNav />
    <CSidebarToggler
      class="d-none d-lg-flex bg-white"
      @click="$store.commit('toggleUnfoldable')"
    />
  </CSidebar>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { AppSidebarNav } from './AppSidebarNav';

export default {
  name: 'AppSidebar',
  components: {
    AppSidebarNav,
  },
  setup() {
    const store = useStore();

    return {
      sidebarUnfoldable: computed(() => store.state.sidebarUnfoldable),
      sidebarVisible: computed(() => store.state.sidebarVisible),
    };
  },
};
</script>
